import React, { useContext, useState } from 'react';
import { Input, Typography } from 'antd';
import { FireOutlined } from '@ant-design/icons';
import AlertCard from './AlertCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const EngineTemperatureAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [temperature, setTemperature] = useState('');
  const [loading, setLoading] = useState(false);

  const triggerTemperatureAlert = async () => {
    setLoading(true);
    await triggerAlert({ serialNo, vehicleKey, actual: temperature, threshold: 100 }, credentials, ALERT_CATEGORY.ENGINE_TEMP_ALERT)
      .then(() => { messageApi.success('Engine temperature alert triggered successfully'); onTriggered?.({ success: true, value: temperature ? `${temperature} °C` : null }); })
      .catch(() => { messageApi.error('Failed to trigger temperature alert'); onTriggered?.({ success: false, value: temperature ? `${temperature} °C` : null }); })
      .finally(() => setLoading(false));
  };

  return (
    <AlertCard
      index={2}
      title="Engine High Temperature"
      icon={<FireOutlined />}
      iconBg="#fff5f5"
      iconColor="#ef4444"
      threshold="100 °C"
      onTrigger={triggerTemperatureAlert}
      triggerLabel="Trigger Temperature Alert"
      loading={loading}
    >
      <Text style={{ fontSize: 11, color: '#64748b' }}>Enter current engine temperature</Text>
      <Input
        placeholder="Temperature in °C"
        type="number"
        value={temperature}
        onChange={(e) => setTemperature(e.target.value)}
        suffix={<Text style={{ color: '#94a3b8', fontSize: 11 }}>°C</Text>}
      />
    </AlertCard>
  );
};

export default EngineTemperatureAlert;
